import { Module, Trigger } from "types/type.module";
import { extractLogicalOperation } from "./Steps";

/**
   @function mapModule 
   map module's triggers, questions and chapters
   @param module {object} - module to map
   @returns {object}
*/

type ModuleMap = {
  triggers: {
    [triggerId: string]: {
      chapterPos: number;
      questionPos: number;
      triggerPos: number;
    };
  };
  questions: {
    [questionId: string]: {
      chapterPos: number;
      questionPos: number;
    };
  };
  chapters: {
    [chapterId: string]: {
      chapterPos: number;
    };
  };
};

export function mapModule(module: Module) {
  const result = module.chapters.reduce(
    (acc: ModuleMap, chapter, chapterIndex) => {
      if (chapter.chapter_id) {
        acc.chapters[chapter.chapter_id] = { chapterPos: chapterIndex };
      }

      chapter.questions.forEach((q, q_i) => {
        if (q.question_id) {
          acc.questions[q.question_id] = {
            chapterPos: chapterIndex,
            questionPos: q_i,
          };
        }

        q.possible_answers.forEach((t, t_i) => {
          if (t.possible_answer_id) {
            acc.triggers[t.possible_answer_id] = {
              chapterPos: chapterIndex,
              questionPos: q_i,
              triggerPos: t_i,
            };
          }
        });

        if (q.conclusion) {
          if (q.question_id) {
            acc.questions[q.question_id] = {
              chapterPos: chapterIndex,
              questionPos: q_i,
            };
          }
        }
      });

      return acc;
    },
    { chapters: {}, questions: {}, triggers: {} }
  );

  return result;
}

export default function translateModule(module: Module) {
  const result = { ...module } as const;

  result.chapters.map((c) => {
    c.questions.map((q) => {
      q.trigger =
        typeof q.trigger === "string"
          ? JSON.parse(q.trigger)
          : JSON.parse(JSON.stringify(q.trigger));
      negateTriggers(q.trigger);
    });
  });

  return result;
}

export function negateTriggers(trigger: any) {
  const operation = extractLogicalOperation(trigger);

  if (operation.operation === "not") {
    delete trigger["not"];

    const toNegate = extractLogicalOperation(operation.elements);
    toNegate.elements?.map((el: any) => {
      if ("question" in el) {
        el.negated = true;
      }
    });
    if (toNegate.operation) {
      trigger[toNegate.operation] = toNegate.elements;
    }
  } else {
    operation.elements?.map((el: any) => {
      if (
        Object.keys(el)[0] === "or" ||
        Object.keys(el)[0] === "and" ||
        Object.keys(el)[0] === "not"
      ) {
        negateTriggers(el);
      }
    });
  }
}
